<template>
    <div id="LinkMessageSlot">
        <div id="link-area">
            <p @click="toLink" v-tippy="{ followCursor: true, placement: 'bottom' }" :content="message.description">
                {{ message.description }}
            </p>
        </div>
        <div id="time-area">
            <p v-if="isUserYou" style="margin-right: 2px">{{ $t("message.you") }}</p>
            <p v-else style="margin-right: 2px">{{ message.user.name }}</p>
            <p>-</p>
            <span style="margin-left: 2px">{{ time }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment/moment";
import Avatar from "vue-avatar";

export default {
    name: "LinkMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    components: {
        Avatar,
    },
    data() {
        return {
            links: [],
            isUserYou: false,
        };
    },
    methods: {
        toLink() {
            const url = `https://${this.message.description}`;
            window.open(url, "_blank");
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        time() {
            const isToday = moment().isSame(moment(this.message.createdDate), "day");
            if (isToday) {
                return moment(this.message.createdDate).format("LTS");
            } else {
                return moment(this.message.createdDate).format("LLL");
            }
        },
        gravatar() {
            return this.message.user.gravatar;
        },
    },
    mounted() {
        if (this.message.user._id === this.user._id) {
            this.isUserYou = true;
        }
    },
};
</script>
